<template>
  <div>
    <div>
      <div class="row my-4 mx-1 justify-content-center">
        <v-container v-if="progress" type="image" class="loding">
          <v-skeleton-loader type="image"></v-skeleton-loader>
        </v-container>
        <div v-else class="col-lg-8 col-sm-12 col-md-10 borderPointier">
          <div class="background-white">
            <div class="title">
              <div class="position">
                {{ $t("Housses d'isolation pour points singuliers") || "Housses d'isolation pour points singuliers" }}
              </div>
            </div>
          </div>

          <form @submit.prevent="houssesIsolationAdd">
            <div class="center mt-3">

             

              <!-- Nombre de housses isolantes mises en place -->
              <b-form-group label="Nombre de housses isolantes mises en place">
                <b-form-input
                  type="number"
                  v-model.number="houssesData.nombre_housses"
                  placeholder=""
                  step="1"
                />
              </b-form-group>

              <!-- Diamètre nominal (DN) de la canalisation (mm) -->
              <b-form-group label="Diamètre nominal (DN) de la canalisation (mm)">
                <b-form-input
                  type="number"
                  v-model.number="houssesData.diametre_nominal_dn"
                  placeholder=""
                  step="1"
                />
              </b-form-group>

              <!-- Température du fluide -->
              <b-form-group label="Température du fluide caloporteur Tfluide (en °C)">
                <b-form-input
                  type="number"
                  v-model.number="houssesData.fluide"
                  placeholder=""
                  step="1"
                />
              </b-form-group>

              <!-- Housse souple, démontable, système de fermeture -->
              <b-form-group label="La housse est souple, démontable et équipée d'un système de fermeture :">
                <div class="d-flex gap-3">
                  <b-form-radio v-model="houssesData.housse_souple_demontable" :value="true" name="housseSouple">Oui</b-form-radio>
                  <b-form-radio v-model="houssesData.housse_souple_demontable" :value="false" name="housseSouple">Non</b-form-radio>
                </div>
              </b-form-group>

              <!-- Laine minérale -->
              <b-form-group label="La housse est constituée d'un isolant à base de laine minérale :">
                <div class="d-flex gap-3">
                  <b-form-radio v-model="houssesData.laine_minerale" :value="true" name="laineMinerale">Oui</b-form-radio>
                  <b-form-radio v-model="houssesData.laine_minerale" :value="false" name="laineMinerale">Non</b-form-radio>
                </div>
              </b-form-group>

              <!-- Température maximale de service -->
              <b-form-group label="Température maximale de service (en °C):">
                <b-form-input
                  type="number"
                  v-model.number="houssesData.temperature_max_service"
                  placeholder=""
                  step="1"
                />
              </b-form-group>

              <!-- Résistance thermique R à 50°C -->
              <b-form-group label="Résistance thermique de l'isolant R (m².K/W) à une température moyenne de 50°C :">
                <b-form-input
                  type="number"
                  v-model.number="houssesData.resistance_thermique_50"
                  placeholder=""
                  step="0.01"
                />
              </b-form-group>

              <!-- Résistance thermique R à 100°C -->
              <b-form-group label="Résistance thermique de l'isolant R (m².K/W) à une température moyenne de 100°C :">
                <b-form-input
                  type="number"
                  v-model.number="houssesData.resistance_thermique_100"
                  placeholder=""
                  step="0.01"
                />
              </b-form-group>

              <!-- Date état récapitulatif -->
              <b-form-group label="Date de l'état récapitulatif, établi par le professionnel à l'issue de travaux, mentionnant les housses isolantes mises en place et les points singuliers isolés :">
                <b-form-input
                  type="date"
                  v-model="houssesData.date_etat_recapitulatif"
                />
              </b-form-group>

            </div>
          </form>
        </div>
      </div>
    </div>

    <div v-if="!show" class="d-flex justify-content-end mt-4">
      <b-button @click="goToPrevStep" class="button-pre-style m-3">
        {{ $t("PREVIOUS") }}
      </b-button>
      <b-button
        type="submit"
        @click="goToStep"
        class="button-suivant-style m-3"
      >
        {{ $t("NEXT") }}
        <div class="loading ml-2" v-if="isLoading">
          <div class="spinner-border spinner-border-sm" role="status"></div>
        </div>
        <div class="loading ml-2" v-if="isLoadingButton">
          <div class="spinner-border spinner-border-sm" role="status"></div>
        </div>
      </b-button>
    </div>
    <Snackbar ref="snackbar" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import domain from "@/environment";
import axios from "axios";
import Snackbar from "@/components/ui/errorSnackbar.vue";

export default {
  components: {
    Snackbar,
  },
  props: {
    show: { type: Boolean, default: false },
    title: { type: String, default: "", required: false },
    visibleTabsLength: { type: Number, required: true },
    isLoadingButton: { type: Boolean, default: false },
    progress: { type: Boolean, default: false },
  },
  data() {
    return {
      houssesData: {
        id: null,
        nombre_housses: null,
        diametre_nominal_dn: null,
        fluide: "",
        housse_souple_demontable: null,
        laine_minerale: null,
        temperature_max_service: "",
        resistance_thermique_50: "",
        resistance_thermique_100: "",
        date_etat_recapitulatif: "",
      },
      isCompleted: false,
      errorMessage: "",
      isLoading: false,
    };
  },
  created() {
    if (this.getdevisMonoFiche && this.getdevisMonoFiche.data) {
      this.houssesData = this.initializeHoussesData();
    }
  },
  computed: {
    ...mapState({ token: (state) => state.token }),
    ...mapGetters(["getdevisMonoFiche"]),
  },
  watch: {
    getdevisMonoFiche: {
      handler(newDevis) {
        if (newDevis && newDevis.data) {
          this.houssesData = this.initializeHoussesData();
          const existing = newDevis.data?.devis?.isolation_points_singuliers_reseau;
          this.isCompleted = existing !== null && existing !== undefined;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    ...mapActions(["setDevisMonoFiche"]),
    toBoolFromApi(value) {
      if (value === 1 || value === true) return true;
      if (value === 0 || value === false) return false;
      return null;
    },
    buildApiPayload() {
      const toNumericBool = (v) => {
        if (v === null || v === "") return null;
        return v ? 1 : 0;
      };
      const devisId = this.getdevisMonoFiche?.data?.devis?.id;
      return {
        ...this.houssesData,
        devis_id: devisId,
        housse_souple_demontable: toNumericBool(this.houssesData.housse_souple_demontable),
        laine_minerale: toNumericBool(this.houssesData.laine_minerale),
      };
    },
    initializeHoussesData() {
      const data = this.getdevisMonoFiche?.data?.devis?.isolation_points_singuliers_reseau || {};
      return {
        id: data.id || null,
        nombre_housses: data.nombre_housses ?? null,
        diametre_nominal_dn: data.diametre_nominal_dn ?? null,
        fluide: data.fluide ?? "",
        housse_souple_demontable: this.toBoolFromApi(data.housse_souple_demontable),
        laine_minerale: this.toBoolFromApi(data.laine_minerale),
        temperature_max_service: data.temperature_max_service ?? "",
        resistance_thermique_50: data.resistance_thermique_50 ?? "",
        resistance_thermique_100: data.resistance_thermique_100 ?? "",
        date_etat_recapitulatif: data.date_etat_recapitulatif ?? "",
      };
    },
    async postIsolationPointsSinguliersReseau(payload) {
      try {
        const response = await axios.post(
          domain + `/isolation_points_singuliers_reseau`,
          payload,
          {
            headers: {
              Authorization: `Bearer ` + this.token,
            },
          }
        );
        return response.data.data;
      } catch (error) {
        if (error.response?.data?.message) {
          this.errorMessage = error.response.data.message;
        } else if (error.response?.data?.errors) {
          this.errorMessage = Array.isArray(error.response.data.errors)
            ? error.response.data.errors.join(", ")
            : error.response.data.errors;
        } else {
          this.errorMessage = "Vérifiez vos données.";
        }
        this.$refs.snackbar.showSnackbar(this.errorMessage);
        return null;
      }
    },
    async putIsolationPointsSinguliersReseau(payload) {
      try {
        const response = await axios.put(
          domain + `/isolation_points_singuliers_reseau/${payload.id}`,
          payload,
          {
            headers: {
              Authorization: `Bearer ` + this.token,
            },
          }
        );
        return response.data.data;
      } catch (error) {
        if (error.response?.data?.message) {
          this.errorMessage = error.response.data.message;
        } else if (error.response?.data?.errors) {
          this.errorMessage = Array.isArray(error.response.data.errors)
            ? error.response.data.errors.join(", ")
            : error.response.data.errors;
        } else {
          this.errorMessage = "Vérifiez vos données.";
        }
        this.$refs.snackbar.showSnackbar(this.errorMessage);
        return null;
      }
    },
    houssesIsolationAdd() {
      const existing = this.getdevisMonoFiche?.data?.devis?.isolation_points_singuliers_reseau;
      const existingId = existing?.id || this.houssesData?.id;

      if (existingId) {
        const payload = { ...this.buildApiPayload(), id: existingId };
        return this.putIsolationPointsSinguliersReseau(payload);
      }
      return this.postIsolationPointsSinguliersReseau(this.buildApiPayload());
    },
    async goToStep() {
      this.isLoading = true;
      this.isCompleted = false;
      this.errorMessage = "";

      const response = await this.houssesIsolationAdd();

      if (response && response.id) {
        this.getdevisMonoFiche.data.devis.isolation_points_singuliers_reseau_id = response.id;
        this.getdevisMonoFiche.data.devis.isolation_points_singuliers_reseau = {
          id: response.id,
          ...this.houssesData,
          housse_souple_demontable: this.houssesData.housse_souple_demontable ? 1 : 0,
          laine_minerale: this.houssesData.laine_minerale ? 1 : 0,
        };
        this.setDevisMonoFiche(this.getdevisMonoFiche);
        this.isCompleted = true;
      }

      this.isLoading = false;
      if (this.isCompleted && this.visibleTabsLength <= 1) {
        this.$emit("change", true);
      }
    },
    goToPrevStep() {
      if (this.visibleTabsLength <= 1) {
        this.$emit("changePrev", true);
      } else {
        this.$emit("changePrev", false);
      }
      this.$emit("changeStep", 3);
    },
  },
};
</script>

<style scoped>
.custom-placeholder::placeholder {
  font-size: 13px;
}
.form-input {
  font-size: 13px;
  height: 41.1px !important;
}
.borderPointier {
  border: 2px dashed #24316d;
  position: relative;
}
.background-white {
  display: inline-block;
  padding: 0.5rem 1rem;
  margin-bottom: 1rem;
  position: absolute;
  top: -1rem;
  left: 0;
  right: 0;
  z-index: 1;
  text-align: center;
}
.title {
  color: #24316d;
  position: relative;
  z-index: 2;
  margin: 0;
}
.position {
  background-color: white;
  display: inline-block;
  padding: 0.05rem 2rem;
}
.custom-input {
  box-shadow: none;
}
</style>
